const front_end_errors = {
    CHECKOUT_VIEW:{
        DELIVERY_METHOD:'Debe seleccionar una forma de entrega',
        ADDRESS_SELECTION:'Debe seleccionar una dirección de entrega',
        PAYMENT_METHOD:'Debe de seleccionar una forma de pago',
        CARD_SELECTION:'Debe de seleccionar una tarjeta',
    }
}

export default front_end_errors